export {
  PatrimonioService,
  Patrimonio,
  PatrimonioProperty,
} from './lib/patrimonio.service';
export * from './lib/patrimonio-data-access.module';
